import React from 'react';
import classnames from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';

import Icon from '../../../../../global/images/icons/Icon';
import PixelToad from '../../../../../components/images/client-portal/8-bit-toad-bw@3x.png';

import { SetViewContext } from '../../PortalContext';

import './ViewAll.scss';

export const NoItemCard = ({ type = 'Quest' }) => (
  <div className="NoQuestsCard mt-10">
    <div className="no-quest-image">
      <img src={PixelToad} alt="No Quests" />
    </div>
    <div>
      No {type}s
    </div>
  </div>
);

export const ItemCard = (props) => {
  const {
    display,
    id,
    image,
    title,
    type,
    warnings = [],
  } = props;

  return (
    <div className={classnames('ItemCard', display)}>
      <div className={classnames('ItemCard__Img', display)}>
        <img className={classnames('ItemCard__Img__Img', display)} src={image} alt={title} />
        {display === 'grid' && (
          !!warnings.length &&
          <Tooltip
            title={`Missing ${warnings.join(', ')} image${warnings.length > 1 ? 's' : ''}. Please contact an admin to provide the missing image${warnings.length > 1 ? 's' : ''}.`}
            placement='top'
          >
            <div className='ItemCard__Img__Warning'>
              <Icon name='warning' color="#FFDBBB" />
            </div>
          </Tooltip>
        )}
      </div>
      <div className={classnames('ItemCard__Info', display)}>
        <div className={classnames('ItemCard__Info__Title', display)}>{title}</div>
        <SetViewContext.Consumer>
          {({ setView, view }) => (
            <div className={classnames('ItemCard__Info__Buttons', display)}>
              <div className={classnames('ItemCard__Info__Buttons__Button', display)}  onClick={() => setView({
                ...view,
                component: `${type}Detail`,
                [`current${type}`]: id,
              })}>
                Details
              </div>
              {display !== 'grid' && (
                !!warnings.length &&
                <Tooltip title={`Missing ${warnings.join(', ')} image${warnings.length > 1 ? 's' : ''}. Please contact an admin to provide the missing image${warnings.length > 1 ? 's' : ''}.`} placement='top'>
                  <div className='ItemCard__Info__Buttons__Warning'>
                    <Icon name='warning' color="#FFDBBB" />
                  </div>
                </Tooltip>
              )}
            </div>
          )}
        </SetViewContext.Consumer>
      </div>
    </div>
  );
};
